export default __webpack_public_path__ + "static/media/socialfi-icon6.27e9b3bb.png";